// @ts-nocheck
import axios from 'axios';
import { isInPWA, platform } from '@/env';
import { useUserInfo } from '@/store';
import md5 from 'crypto-js/md5';
import { ev } from '@/consts'

// facebook
const _init_fb = () => {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );
}

// tiktok
const _init_tt = () => {
  !function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
  var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
  ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
  }(window, document, 'ttq');
}

const trackName = {
  // 第一次打开页面 - 查看内容
  ViewContent: 'ViewContent',
  // 用户注册成功 - 完成注册
  CompleteRegistration: 'CompleteRegistration',
  // 用户登录成功 - 登录
  SubmitApplication: 'SubmitApplication',
  // 点击进入游戏 - 开始试用游戏
  StartTrial: 'StartTrial',
  // 进入充值页面 - 加入购物车   //进入到充值页面
  AddToCart: 'AddToCart',
  // 创建订单成功 - 拉起订单
  InitiateCheckout: 'InitiateCheckout',
  // 用户完成首次充值 - 首充事件
  Purchase: 'Purchase',
  // ttq 首充事件
  Subscribe: 'Subscribe',
  // 点击安装PWA后 - 点击安装pwa
  CustomizeProduct: 'CustomizeProduct'
}

const events = {
  fa: ['ViewContent', 'AddToCart'],
  fp: ['ViewContent', 'CompleteRegistration', 'SubmitApplication', 'StartTrial', 'AddToCart', 'InitiateCheckout', 'Purchase'],
  tpl: ['ViewContent', 'CompleteRegistration', 'SubmitApplication', 'StartTrial', 'AddToCart', 'InitiateCheckout', 'Subscribe'],
}

let curEvs = []

const request = axios.create({
  baseURL: import.meta.env.VITE_REPORT_URL
});

let trackFn = null;
let trackType = null

const _init = (pixelId: string, type: 'fa' | 'fp' | 'tpl') => {
  if (!pixelId || !type || !(type in events)) return

  curEvs = events[type]
  trackType = type

  if (type === 'fa' || type === 'fp') {
    _init_fb()

    fbq('init', pixelId);
    trackFn = (eventName, params = {}) => {
      if (!eventName) return;
      JSON.stringify(params) === '{}'
        ? fbq('track', eventName)
        : fbq('track', eventName, params);
    }
  }

  if (type === 'tpl') {
    _init_tt()

    ttq.load(pixelId);
    ttq.page();
    trackFn = (eventName, params = {}) => {
      if (!eventName) return;
      JSON.stringify(params) === '{}'
        ? ttq.track(eventName)
        : ttq.track(eventName, params);
    };
  }
}

const init = () => {
  const { channelType, channelPixelId } = useUserInfo().userInfo || {channelType: 0, channelPixelId: ''}
  if (channelType == 0) return

  if (channelType && channelPixelId) {
    const pixelId = channelPixelId
    _init(pixelId, channelType)
  }
}

ev.on('login', () => {
  init()
})

ev.on('restore', (d: any) => {
  if (d[0].userInfo && d[1].$id === 'userInfo') init()
})

ev.on('logout', () => {
  trackFn = null
  trackType = null
  curEvs = []
})

export default function useTrack() {
  return {
    trackName,

    track2Platform(eType: string, params: any = {}) {
      if (!trackFn || !eType || !trackName[eType]) return

      if (eType === trackName.Purchase && trackType === 'tpl') {
        eType = 'Subscribe'
      }

      if (!curEvs.includes(eType)) return

      const { visitIp: ip, userid } = useUserInfo().userInfo || {}

      const trackParams = {
        event_id: eType + '_' + md5(userid).toString(),
        client_orgin: platform === 'android' ? 'APK' : isInPWA ? 'PWA' : 'website',
        client_ip_address: ip,
        client_user_agent: navigator.userAgent,
      }

      trackFn(eType, { ...params, ...trackParams });
    },

    track(data) {
      request({
        url: `/info_upload`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          ...data,
          user_ip: localStorage.getItem('clientIp'),
        },
      })
    }
  }
}
